<template lang="pug">
.new-tech-item(@click="$emit('click')")
  //img.cover(:src="itemData.cover")
  .info
    .title {{ itemData.title }}
    .extend
      span.category {{ itemData.category }}
      span.read-count {{ itemData.readCount }}
</template>

<script>
export default {
  name: "ListMoreItem",
  props: {
    itemData: Object
  }
}
</script>

<style lang="scss" scoped>
.new-tech-item{
  display: flex;
  padding: 8px 0;
  cursor: pointer;
  .cover{
    flex: 0 0 120px;
    @include size(120px, 90px);
    object-fit: cover;
    margin-right: 16px;
  }
  .info{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title{
      font-size: 16px;
      color: #202948;
    }
    .extend{
      font-size: 12px;
      color: rgba(0, 0, 0, 0.4);
      .category{
        margin-right: 12px;
      }
    }
  }
}
</style>
